import { createContext } from 'react';
export const CheckboxGroupContext = createContext(null);